<template>
  <div class="preferential-container">
    <Appbar :title="data.title"></Appbar>

    <v-card v-if="data.activityId" class="card-box ">
      <!-- <img style="vertical-align: top; width: 100%" :src="data.titleImg" alt="" /> -->
      <div
        style="overflow: auto"
        :id="`editor${htmlId}`"
        v-html="data.isEnableContentMobile == 1 ? data.contentMobile : data.content"
      ></div>
    </v-card>
    <div class="page-loading" v-else>
      <v-progress-circular
        indeterminate
        size="30"
        :color="$vuetify.theme.themes.light.buttonColor || $vuetify.theme.themes.light.headerBgColor"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import Appbar from '@c/layout/Appbar'
import { ApigetById } from '@/api/service.js'
export default {
  components: {
    Appbar
  },
  data() {
    return {
      activityId: '',
      data: {},
      loading: false,
      //   htmlId: this.$tools.random(0, 100)
      htmlId: String(Math.random()).slice(-3)
    }
  },
  computed: {
    _cdn() {
      return this.$store.getters['app/cdn']
    }
  },
  created() {
    // this.$store.dispatch("service/getServiceTime"); //更新当前系统时间
    this.getData()
  },
  methods: {
    getData() {
      let activityId = this.$route.query.activityId
      this.loading = true
      ApigetById({ activityId }).then(res => {
        //   td p{text-align:center}
        this.loading = false
        if (res.code != 'ERROR') {
          //   console.log('res.code :', res.data)
          //   const tempCss = `<style>
          //             .preferential-container span{white-space:normal !important;text-wrap:wrap !important;}
          //             table {border: 1px solid #ccc;border-collapse: collapse;}
          //             th,td {border: 1px solid #ccc;padding:3px}p{margin-bottom:0 !important;}
          //             table a{text-decoration: underline;padding: 5px 0;display: inline-block;}
          //             code{padding:0 !important;}

          //             </style>`
          //   res.data.content += tempCss
          //   res.data.contentMobile += tempCss
          this.data = res.data
          this.$nextTick(() => {
            window.uParse(`#editor${this.htmlId}`, {
              rootPath: this._cdn + '/pc/common/Ueditor/third-party'
            })
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.v-application--wrap {
  overflow: scroll;
}
.preferential-container {
  .card-box {
    border-radius: 0px !important;
    padding: 6px !important;
  }
}
</style>
